export default __webpack_public_path__ + "static/media/agent.4ae4741d.png";